// src/layouts/AdminLayout.jsx
import { useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import DashboardHeader from '../../../Components/DashboardHeader';
import AdminSidebar from './../../../Components/AdminSidebar';

export default function AdminLayout() {
  const location=useLocation()
  const [collapsed, setCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  const toggleSidebar = () => {
    if (window.innerWidth < 1024) {
      setMobileOpen(!mobileOpen);
    } else {
      setCollapsed(!collapsed);
    }
  };

const isChat=location?.pathname==="/Admin/Dashboard/Chat"
  return (
    <div
    style={{ background:isChat?"#212C43" :'linear-gradient(135deg,rgba(18, 25, 46, 1) 30%, #2E428A 100%' }}
     className="flex h-screen overflow-hidden">
      <AdminSidebar 
        collapsed={collapsed} 
        mobileOpen={mobileOpen}
        onCloseMobile={() => setMobileOpen(false)}
      />
      <div className="flex flex-col flex-1 ">
     {  !isChat? <DashboardHeader onToggleSidebar={toggleSidebar} />:null}
        <div className="flex-1 overflow-y-auto  ">
          <Outlet />
        </div>
      </div>
    </div>
  );
}

